import React, {useMemo, useRef} from 'react';
import ApolloClient from 'apollo-client';
import {ApolloProvider} from '@apollo/react-hooks';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {setContext} from 'apollo-link-context';
import {useSelector} from 'react-redux';
import {linkApp, defaultOptions} from 'src/common/gqlClientes';

// The name here doesn't really matters.
export default function CustomApolloProvider(props) {
   const token = useSelector(state => state.auth.token);
   const tokenRef = useRef();

   // Whenever the token changes, the component re-renders, thus updating the ref.
   tokenRef.current = token;

   // Ensure that the client is only created once.
   const client = useMemo(() => {
      const authLink = setContext((_, {headers}) => ({
         headers: {
            ...headers,
            authorization: tokenRef.current ? `Bearer ${tokenRef.current}` : ''
         }
      }));

      return new ApolloClient({
         link: authLink.concat(linkApp),
         cache: new InMemoryCache(),
         defaultOptions
      });
   }, []);

   return <ApolloProvider client={client} {...props} />;
}
